/* Global */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* Services */
import { GuardService } from './services/guard.service';


const routes: Routes = [
  {
    path: '',
    loadChildren: './session/session.module#SessionModule'
  },
  {
    path: 'dashboard',
    loadChildren: './dashboard/dashboard.module#DashboardModule',
    canActivate: [ GuardService ]
  },
  {
    path: 'categories',
    loadChildren: './categories/categories.module#CategoriesModule',
    canActivate: [ GuardService ]
  },
  {
    path: 'users',
    loadChildren: './users/users.module#UsersModule',
    canActivate: [ GuardService ]
  },
  {
    path: 'search',
    loadChildren: './search/search.module#SearchModule',
    canActivate: [ GuardService ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
